import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import HotelDetailsOverlay from 'components/Accommodation/HotelDetailsOverlay';
import { AllOffersOverlay } from 'components/Accommodation/Offers/AllOffersOverlay';
import { AvailabilityPopupWrapper } from 'components/AvailabilityCalendarPopup/AvailabilityPopupWrapper';
import CookieBanner from 'components/CookieBanner';
import { ExitPopupSearchPage } from 'components/ExitPopup';
import { FiltersOverlay } from 'components/FiltersOverlay/FiltersOverlay';
import SpinnerImportLoader from 'components/Loaders/SpinnerImportLoader';
import { MapOverlay } from 'components/MapOverlay';
import Search from 'components/Search';
import SearchBoxShadow from 'components/SearchBoxShadow';
import { SearchLayoutContainer } from 'components/SearchLayoutContainer';
import { ShowMapFloatingButton } from 'components/ShowMapFloatingButton/ShowMapFloatingButton';
import { SortByMobile } from 'components/SortBy/SortByMobile';
import { SplashScreenRemover } from 'components/SplashScreenRemover';
import { OfferViewContext, OfferViewType } from 'context/offerViewContext';
import { useConditionalEffect } from 'hooks/useConditionalEffect';
import { useHandleUserGeolocation } from 'hooks/useHandleUserGeolocation';
import { useRedirectToHomeIfGeolocationFails } from 'hooks/useRedirectToHomeIfGeolocationFails';
import { useShowHotelDetailsFromUrlParams } from 'hooks/useShowHotelDetailsFromUrlParams';
import { useTrackPageScroll } from 'hooks/useTrackPageScroll';
import { getModuleState } from 'modules/sapiSearch/selectors';
import { ModuleState } from 'modules/sapiSearch/slice';
import { useInitSearch } from 'modules/sapiSearch/useSapiSearch';
import { loadModule } from 'utils';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
const Map = loadModule(async () => import( /* webpackChunkName: "Map" */
'components/Map'), {
  loading: SpinnerImportLoader
});
const SearchWrapper = /*#__PURE__*/styled('div')({
  name: "SearchWrapper",
  class: "sjy462y",
  propsAsIs: false
});
const SearchView = () => {
  const {
    isMobile,
    isDesktop
  } = useDeviceLayout();
  const {
    brandHasExitPopup,
    brandHasMap
  } = useBrand();
  const moduleState = useSelector(getModuleState);
  const searchStateDataId = useMemo(() => {
    switch (moduleState) {
      case ModuleState.SearchCompleted:
        return 'SearchCompleted';
      default:
        return 'SearchIdle';
    }
  }, [moduleState]);
  useConditionalEffect(async () => import( /* webpackChunkName: "HotelDetailsTabs" */
  /* webpackPrefetch: true */
  'components/HotelDetailsTabs/HotelDetailsTabs'), !isMobile);
  useConditionalEffect(async () => import( /* webpackChunkName: "HotelDetailsOverlayDesktop" */
  /* webpackPrefetch: true */
  'components/Accommodation/HotelDetailsOverlay/Desktop/HotelDetailsOverlayDesktop'), !isMobile);
  return <>
      <SplashScreenRemover />
      {isMobile && <>
          <FiltersOverlay />
          <MapOverlay mapComponent={<Map />} />
          <SortByMobile />
          {brandHasMap && <ShowMapFloatingButton />}
        </>}
      {!isMobile && <AllOffersOverlay variant="popup" sourceComponent="DesktopOffersTab" />}
      <SearchWrapper data-id={searchStateDataId}>
        {brandHasExitPopup && <OfferViewContext.Provider value={OfferViewType.SRP_BEST_DEAL_MODAL}>
            <ExitPopupSearchPage />
          </OfferViewContext.Provider>}
        <SearchBoxShadow>
          <SearchLayoutContainer listComponent={<Search />} mapComponent={<Map />} />
          <HotelDetailsOverlay />
          {isDesktop && <AvailabilityPopupWrapper />}
          {!isMobile && <CookieBanner />}
        </SearchBoxShadow>
      </SearchWrapper>
    </>;
};
const MemoSearchView = React.memo(SearchView);
export const SearchViewContainer = () => {
  useInitSearch();
  useTrackPageScroll();
  useHandleUserGeolocation();
  useShowHotelDetailsFromUrlParams();
  useRedirectToHomeIfGeolocationFails();
  return <MemoSearchView />;
};

require("./Search.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Search.tsx");